module.exports = __webpack_public_path__ + "img/logo.17ceee2f.png";